export default "__VITE_ASSET__6308dbf0__"